import script from "./DraftPlanPopup.vue?vue&type=script&setup=true&lang=js"
export * from "./DraftPlanPopup.vue?vue&type=script&setup=true&lang=js"

import "./DraftPlanPopup.vue?vue&type=style&index=0&id=1ec70fc2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1ec70fc2"]])

export default __exports__